import { Container } from './Animate.styles';
import { AnimateProps } from '@sleepunique/types/animate-type';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
  },
};

const Animate = ({ children }: AnimateProps) => (
  <Container variants={container} initial="hidden" animate="show">
    {children}
  </Container>
);

export default Animate;
